import { msg } from '@lingui/core/macro'
import { createFileRoute } from '@tanstack/react-router'
import { useProjectDetail } from '~/components/projects/project-detail'
import { ProjectRendersTab } from '~/components/renders/project-renders-tab'
import { titleFor } from '~/lib/route-title'

const ProjectRendersRoute = () => {
  const project = useProjectDetail()

  return (
    <div className="px-5 pb-6">
      <ProjectRendersTab projectId={project._id} readOnly={project.outcome === 'lost'} />
    </div>
  )
}

export const Route = createFileRoute('/_authenticated/$workspaceSlug/projects/$projectId/renders')({
  component: ProjectRendersRoute,
  head: () => ({ meta: [{ title: titleFor(msg`Renders`) }] }),
})
